import './styles.scss';

export type imageSizeType =
  | 'xxxs'
  | 'xxs'
  | 'xs'
  | 's'
  | 'm'
  | 'l'
  | 'xl'
  | 'xxl'
  | 'xxxl';

interface IProps {
  alt?: string;
  src: string | undefined;
  size: imageSizeType;
  onClick?: any;
  otherProps?: any;
  className?: string;
  onError?(): void;
}

const Image = (props: IProps) => {
  if (!props.src) {
    return <div className={`image image--${props.size}`}></div>;
  } // placeholder if no image
  return (
    <img
      {...props}
      onClick={props.onClick ? props.onClick : undefined}
      onMouseDown={(e) => e.preventDefault()}
      className={`image image--${props.size} ${
        props.className ? props.className : ''
      } ${props.onClick ? 'image--clickable' : ''}`}
      src={props.src}
      alt=''
      onError={props.onError}
    />
  );
};

export default Image;
